import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NoTrialAccess = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ p: 4, maxWidth: 560, mx: 'auto', mt: 8, textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        No trial access yet
      </Typography>
      <Typography color="text.secondary" paragraph>
        Your account is active, but you have not been assigned to a trial or site. Please contact your
        administrator to be assigned to a study.
      </Typography>
      <Button variant="outlined" onClick={() => navigate('/help')}>
        Help &amp; support
      </Button>
    </Box>
  );
};

export default NoTrialAccess;
